<template>
  <div :class="{ 'no-tab-bar': !showNavBar }" class="selected-message">
    <div :class="{ 'no-tab-bar': !showNavBar, 'loaded': headerImageLoaded }" class="image" v-if="message.ImageUrl || message.MobileImageUrl">
      <img :src="imageSrc" @load="loaded" :class="{ 'loaded': headerImageLoaded }" />
    </div>
    <div class="scroll-area">
      <div class="title" v-if="message.Title">{{ message.Title }}</div>
      <div class="message-body" v-if="message.Message" v-html="message.Message"></div>
      <div class="bottom-info">
        <span v-if="message.Date">{{ translations.recieved }} {{ formatDateString(message.Date) }}</span>
        <span v-if="message.Expires">
          | {{ translations.validUntil }} {{ formatDateString(message.Expires) }}
        </span>
        <br />
        {{ translations.questionsShort }} <a :href="mailtoLink">{{ supportText }}</a>
      </div>
    </div>
    <div class="bottom-row">
      <div class="footer-text" v-if="message.FooterText && termsAboveButtons" v-html="message.FooterText"></div>
      <div class="buttons-row">
        <a class="cta-button" v-if="message.CTAButtonText && message.CTAButtonLink" :href="message.CTAButtonLink" @click.prevent="$emit('hrefClicked', { data: message, href: message.CTAButtonLink })">{{ message.CTAButtonText }}</a>
        <a class="cta-button secondary" v-if="message.CTAButton2Text && message.CTAButton2Link" :href="message.CTAButton2Link" @click.prevent="$emit('hrefClicked', { data: message, href: message.CTAButton2Link })">{{ message.CTAButton2Text }}</a>
      </div>
      <div class="footer-text" v-if="message.FooterText && !termsAboveButtons" v-html="message.FooterText"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatDate, convertToISO } from '../../utils/date';


export default {
  name: 'Inboxmessage',
  props: {
    authToken: {
      type: String,
    },
    fusionUrl: {
      type: String,
    },
    message: {
      type: Object,
    },
    translations: {
      type: Object,
    },
    contactEmail: {
      type: String,
    },
    mailtoLink: {
      type: String,
    },
    supportText: {
      type: String,
    },
    showNavBar: {
      type: Boolean,
    },
    termsAboveButtons: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
    }),
    imageSrc() {
      if (this.isMobile && this.message.MobileImageUrl) {
        return this.message.MobileImageUrl;
      }

      return this.message.ImageUrl;
    },
  },
  data() {
    return {
      headerImageLoaded: false,
    };
  },
  mounted() {
    this.markNotificationAsRead();
  },
  methods: {
    formatDateString(dateStr) {
      return formatDate(convertToISO(dateStr));
    },
    loaded() {
      this.headerImageLoaded = true;
    },
    markNotificationAsRead() {
      if (this.message.Event === 'shoutout') return;
      if (!this.message || !this.message.MessageId || this.message.IsRead) return;
      if (this.message.IsLocalMessage) return;
      this.$emit('messageRead', this.message);
    },
  },
};
</script>

<style lang="less">
#fasttrack-crm {
  .selected-message {
    font-family: "Lato", sans-serif;
    width: 100%;
    max-width: 100%;
    min-height: 40vh;
    height: 100%;
    max-height: 100%;

    background-color: #fff;
    position: relative;
    transition: 300ms;
    transition: 10s;
    transition: all 250ms ease-in-out;

    display: flex;
    flex-direction: column;

    border-radius: 6px;

    &.no-tab-bar {
      overflow: hidden;
    }

    .scroll-area {
      overflow-y: scroll;
      flex-grow: 1;
    }

    .image {
      width: 100%;
      transition: all 300ms ease;
      background-color: #eeeeee;

      img {
        width: 100%;
        height: auto;
        display: block;
        opacity: 0;
        transition: all 300ms ease;

        &.loaded {
          opacity: 1;
        }
      }

      &.no-tab-bar {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
      }
    }

    .title {
      color: #000;
      font-size: 28px;
      font-weight: 900;
      display: block;
      margin: 10px 25px 10px 25px;
      text-align: left;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: "Lato", sans-serif;
      color: #000;
      font-weight: 600;
      margin-bottom: 0;
      padding: 0;
    }

    h2 {
      font-size: 21px;
    }

    h3 {
      font-size: 18px;
    }

    h4 {
      font-size: 16px;
    }

    h5 {
      font-size: 12px;
    }

    h6 {
      font-size: 12px;
    }

    .message-body {
      margin: 10px 25px 10px 25px;
      font-size: 14px;
      line-height: 1.4;
      color: #333;
      text-align: left;

      a {
        color: #2d72ee;
        font-weight: 700;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }

      b {
        font-weight: 700;
      }
    }

    .bottom-row {
      padding: 10px 0px 10px 0px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
    }

    .buttons-row {
      margin: 0px 25px 0px 25px;
      display: flex;
      justify-content: space-around;
      flex-direction: row;
      flex-wrap: wrap;

      a {
        flex-grow: 1;
        min-width: 25%;
        max-width: 48%;
        flex-basis: 200px;
      }
    }

    .footer-text {
      font-size: 10px;
      color: #545454;
      margin: 0 auto;
      padding: 0px 25px 10px 25px;
      text-align: center;
    }

    .bottom-info {
      font-size: 8px;
      color: #545454;
      padding: 10px 25px 10px 25px;
      margin: 20px 25px 0px 25px;
      text-align: center;
      margin-top: 20px;
      border-top: 1px solid rgba(0, 0, 0, 0.1);

      a {
        text-decoration: none;
        font-weight: 700;
        color: inherit;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
